module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAYAAAAJKR1YAAAA3ElEQVRIie2UwQ2CMBSGP4gr6BDqCDTKBPTi0V3w7jCMoCmu4BAugQdoYgqGlrRSE77kXXp4+fre3yZFUSggIw7qlHhkALJ0bgOTRWiM6IRW5oEQwqmBUsqbDPzDhHzf2JX4J+SaIVfGNhD/hJYMGfw8QybmRuKf0JIhgyiF6rklPnikgAASYA9cgKen5ncg73rbVpY0TdPrJKXcAaeuthNEyqqqblNuMShkyG2AK3AOKWIt1EmtgVdIEU3vH/rC0Nq8imhshcrQIppRISnlATiGFrEWon26eWgRzRtY6UR0cagBQQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/analyst-icon.png
// module id = Z/KV
// module chunks = 172